import React from "react";

import {useAppSelector} from "../../../store/hooks";
import {VendorDetailSoldOffersPageSize} from "../../constants/VendorDetailSoldOffersPageSize";
import {VendorDetailUnavailableOffersPageSize} from "../../constants/VendorDetailUnavailableOffersPageSize";
import {useVendorUnavailableOfferLists} from "../../hooks/use_vendor_unavailable_offer_lists";
import {IVendorDetail} from "../../types/IVendorDetail";
import {UnavailableOffersList} from "./UnavailableOffersList";

interface IProps {
    vendorSlug: string;
    vendorDetail: IVendorDetail;
}

export const VendorDetailUnavailableOffersLists: React.FC<IProps> = ({vendorSlug, vendorDetail}) => {
    const region = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.region);

    const {sold, inactive} = useVendorUnavailableOfferLists({vendorId: vendorDetail.id, region});

    return (
        <>
            <UnavailableOffersList
                title="Inwestycje zrealizowane"
                type="archive"
                vendorSlug={vendorSlug}
                pageSize={VendorDetailSoldOffersPageSize}
                offers={sold.offers}
                isFetching={sold.isFetching}
                count={sold.count}
                page={sold.page}
                onLoadMore={sold.loadMore}
                onReset={sold.reset}
            />
            <UnavailableOffersList
                title="Oferty nieaktywne"
                type="inactive"
                vendorSlug={vendorSlug}
                pageSize={VendorDetailUnavailableOffersPageSize}
                offers={inactive.offers}
                isFetching={inactive.isFetching}
                count={inactive.count}
                page={inactive.page}
                onLoadMore={inactive.loadMore}
                onReset={inactive.reset}
            />
        </>
    );
};
import React from "react";

import {useAppSelector} from "../../../store/hooks";
import {VendorDetailSoldOffersPageSize} from "../../constants/VendorDetailSoldOffersPageSize";
import {VendorDetailUnavailableOffersPageSize} from "../../constants/VendorDetailUnavailableOffersPageSize";
import {useVendorUnavailableOfferLists} from "../../hooks/use_vendor_unavailable_offer_lists";
import {IVendorDetail} from "../../types/IVendorDetail";
import {UnavailableOffersList} from "./UnavailableOffersList";

interface IProps {
    vendorSlug: string;
    vendorDetail: IVendorDetail;
}

export const VendorDetailUnavailableOffersLists: React.FC<IProps> = ({vendorSlug, vendorDetail}) => {
    const region = useAppSelector((state) => state.vendorDetailViewSlice.activeOffersListParams.region);

    const {sold, inactive} = useVendorUnavailableOfferLists({vendorId: vendorDetail.id, region});

    return (
        <>
            <UnavailableOffersList
                title="Inwestycje zrealizowane"
                type="archive"
                vendorSlug={vendorSlug}
                pageSize={VendorDetailSoldOffersPageSize}
                offers={sold.offers}
                isFetching={sold.isFetching}
                count={sold.count}
                page={sold.page}
                onLoadMore={sold.loadMore}
                onReset={sold.reset}
            />
            <UnavailableOffersList
                title="Oferty nieaktywne"
                type="inactive"
                vendorSlug={vendorSlug}
                pageSize={VendorDetailUnavailableOffersPageSize}
                offers={inactive.offers}
                isFetching={inactive.isFetching}
                count={inactive.count}
                page={inactive.page}
                onLoadMore={inactive.loadMore}
                onReset={inactive.reset}
            />
        </>
    );
};
